var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_c('router-link',{attrs:{"to":"/"}},[_c('h1',[_c('img',{staticStyle:{"height":"50px"},attrs:{"src":require("@/assets/image/n_logo.jpg"),"alt":"로고"}})])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }